import { Link } from "react-router-dom";
import { ArrowRight } from "../../component/icon/arrowRight";
import MyselfImg from "../../component/image/myself.png";
import "./about.css";

const About = () => {
  return (
    <div className={"containerAbout"}>
      <div className={"about"}>
        <div className={"aboutTop"}>
          <img alt={MyselfImg} src={MyselfImg} className={"aboutImg"} />
          <div className={"aboutMe"}>
            <span className={"aboutTitle"}>Présentation</span>
            <div className={"aboutDescription"}>
              Bonjour ! Je m'appelle Jennifer et je vis à Toulouse. Cela fait
              maintenant plus de 4 ans que je suis développeuse web, spécialisée
              en front-end et plus particulièrement en React. Depuis peu, je me
              lance aussi dans le fullstack, en explorant Node.js, C# et les
              architectures backend, afin de pouvoir intervenir sur l’ensemble
              d’un projet web. Aujourd'hui, je suis à la recherche de missions
              en freelance ou d'un poste en CDI.
              <br /> <br />
              En parallèle de la programmation, je suis passionnée par la
              psychologie, au point où j'ai repris mes études dans ce domaine.
              Et quand je ne code pas ni n’étudie, je me détends en jouant à des
              jeux de société ou des jeux vidéo.
            </div>
          </div>
        </div>
        <div className={"aboutTech"}>
          <span className={"aboutTitle"}>L'informatique</span>
          <div className={"aboutDescription"}>
            En 2016, mon aventure en informatique a débuté avec{" "}
            <Link
              className={"aboutLink"}
              to={"https://42.fr/"}
              target={"_blank"}
            >
              l'école 42
            </Link>
            . 42 est une école d’informatique innovante où l’apprentissage se
            fait en totale autonomie. Sans cours ni professeurs, l’école repose
            sur un apprentissage basé sur des projets et des peer reviews, une
            méthode qui m’a permis de développer ma capacité à résoudre des
            problèmes de manière indépendante et à travailler efficacement en
            équipe. J'y ai appris des langages comme le C, le Shell,
            l'algorithmique, ainsi que les bases du développement web avec PHP,
            HTML, CSS, JavaScript, Angular et enfin React, que j'utilise
            aujourd’hui pour construire des applications modernes et
            performantes.
            <br /> <br />
            En 2020, j'ai rejoint l'équipe{" "}
            <Link
              className={"aboutLink"}
              to={"https://www.tactill.com/"}
              target={"_blank"}
            >
              Tactill
            </Link>{" "}
            pour une mission de 3 ans en tant que développeuse front-end afin de
            commencer le développement d'une toute nouvelle application web en
            React.
          </div>
          <Link className={"linkExperience"} to={"/experience"}>
            <div className={"linkIcon"}>
              <ArrowRight />
            </div>
            <div>Voir mes expériences</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export { About };
